import * as React from 'react';
import { useState } from 'react';
import Box from "@material-ui/core/Box";
import { ApplicationState } from "../../redux/reducers";
import { connect } from "react-redux"
import { setSolicitud, setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { ITipoEnvio } from "../../entities/catalogos/ITipoEnvio";
import NextButton from "../controls/NextButton";
import { useSnackbar } from 'notistack';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    createStyles,
    Grid,
    makeStyles,
    Theme,
    Typography
} from "@material-ui/core";
import TipoEnvio from "./TipoEnvio";
import { enums } from "../../enums/enums";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { Mercancia } from "../../entities/solicitudes/Mercancia";
import { ICliente } from "../../entities/catalogos/ICliente";
import useCommonApi from '../../api/useCommonApi';
import LoadingDialog from '../controls/LoadingDialog';
import { ISolicitudDto } from '../../entities/solicitudes/SolicitudDto';
import { ISolicitudServicioDto } from '../../entities/solicitudes/ISolicitudServicioDto';
import { Add } from '@material-ui/icons';
import CartaInstruccion from './CartaInstruccion';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import { initialSolicitud } from '../../redux/reducers/solicitudReducer';
import { initialMercancia } from '../../redux/reducers/mercanciaReducer';
import { saveMercancias } from '../../redux/actions/mercanciaActions';
import swal from 'sweetalert2'
import { Contacto } from '../../entities/catalogos/Contacto';
import { Colonia } from '../../entities/catalogos/Colonia';
import Help, { IHelp } from '../help/Help';
import { MercanciaDatosComplementarios } from '../../entities/solicitudes/MercanciaDatosComplementarios';
import { setServiciosAdicionales } from "../../blocks/utility";
import Checkbox from "@material-ui/core/Checkbox";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import SubmitButton from "../controls/SubmitButton";
import Markup from '../markup/Markup';
import { IResultApi } from '../../interfaces/IResultApi';
import { saveCliente } from '../../redux/actions/clienteActions';
import { Sucursal } from '../../entities/catalogos/Sucursal';
import { IClienteSku } from '../controls/AutocompleteControl';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({

        heading: {
            fontSize: "0.875rem",
            color: "#00653b",
            fontWeight: theme.typography.fontWeightBold,
            borderBottom: "2px solid #00653b"
        },
        border: {
            fontSize: theme.typography.pxToRem(20),
            fontWeight: theme.typography.fontWeightBold,
            textAlign: "center"
        },
        actions: {
            width: "100%",
            textAlign: "right",
            paddingTop: "20px",
            backgroundColor: "#ccc"
        },
        link: {
            color: "#0094ff",
            fontSize: "12px",
            fontWeight: 500,
            cursor: "pointer"
        },
    }),
);

interface OwnProps {
    siguienteSeccion: (estatusId: number, cotizacionCopia: Solicitud, cotizacion_ID?: number, contacto?: any, datosRemitente?: any, datosDestinatario?: any, solicitudDTO?:any) => void
    cotizacionId: number,
}

interface StateProps {
    solicitud: Solicitud
    solicitudCopia: Solicitud
    mercancias: Mercancia[]
    mercanciasComplementarias: MercanciaDatosComplementarios[]
    cliente: ICliente
    tiposEnvio: ITipoEnvio[]
    usuario: IUsuario
    ayuda: IHelp
    solicitudDTO: any
}

interface DispatchProps {
    setSolicitudCopia: typeof setSolicitudCopia
    setSolicitud: typeof setSolicitud
    saveMercancias: typeof saveMercancias
    saveCliente: typeof saveCliente
}

interface IResultAuthApi extends IResultApi {
    response: { token: string, refreshToken: string }
}

interface IDatosLogin {
    resultAuthApi: IResultAuthApi
    cliente: ICliente
    etiquetas: any,
    idioma: string,
    diasRAD: string,
    tieneConveniosHD: boolean
}

type Props = OwnProps & StateProps & DispatchProps & IDatosLogin
const apiSource = useCommonApi();

const TipoEnvioSolicitudLista = (props: Props) => {
    const [state, setState] = useState<Solicitud>(props.solicitudCopia);
    const { enqueueSnackbar } = useSnackbar();
    const apiSourceCommon = useCommonApi();
    const [showLoading, setLoading] = useState(false);
    let panelExpand = "TipoEnvio";
    let habilitaMark = true;
    let habilitaCarta = true;
    if(props.solicitud.completadaMarkup && (props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo)){
        panelExpand="Markup";
        habilitaMark = false;
        habilitaCarta = false;
    }
    const [markupHabilitado, setMarkupHabilitado] = useState(habilitaMark);
    const [expanded, setExpanded] = useState<string | false>(panelExpand);
    const [cartaHabilitado, setCartaHabilitado] = useState(habilitaCarta);
    let tipoMarkup = 0;
    if(props.solicitudCopia.tipoMarkupId !== undefined && props.solicitudCopia.tipoMarkupId!== null)
        tipoMarkup = props.solicitudCopia.tipoMarkupId;
    const [tipo, setTipo] = useState(tipoMarkup);
    const classes = useStyles();
    const [archivosAdjuntos, setArchivosAdjuntos] = useState<any[]>([]);
    const [datosRemitente, setdatosRemitente] = useState<any>({ nombre: '', latitude: 0, longitude: 0, direccion: '' });
    const [datosDestinatario, setdatosDestinatario] = useState<any>({ nombre: '', latitude: 0, longitude: 0, direccion: '' });
    const [aceptaTerminos, setAceptaTerminos] = useState(false);
    const [tiposEnvioIcono] = useState<any[]>([
        { id: 1, icono: "SERVICIO_ALMEX" },
        { id: 2, icono: "ALMEX_PRIORITY" },
        { id: 3, icono: "ALMEX_PROXIMITY", },
        { id: 4, icono: "ALMEX_ONE" },
    ]);
    const [totalValidaMarkup, setTotalValidaMarkup] = useState(0);
    const [montoMarkup, setMontoMarkup] = useState(0);
    const [porcentajeMarkup, setPorcentajeMarkup] = useState(0);
    const [tipoMarkupId, setTipoMarkupId] = useState(0);
    const [esInternamiento, setEsInternamiento] = useState(props.solicitud.cruceFronterizo?.esIntraUSA ?? false);

    const getTotalPesoFacturado = (solicitud) => {

        var total = 0;
        if (solicitud.solicitudDesgloseFlete.length) {
            total = (solicitud.solicitudDesgloseFlete.reduce((a,v) => a = a + v.valor, 0));
        }
        if (solicitud.solicitudDesgloseFleteEad.length) {
            total += solicitud.solicitudDesgloseFleteEad[0].valor;
        }
        if (solicitud.solicitudDesgloseFleteRad.length) {
            total += solicitud.solicitudDesgloseFleteRad[0].valor;
        }
        if (solicitud.solicitudDesgloseFleteAjuste.length) {
            total += solicitud.solicitudDesgloseFleteAjuste[0].valor;
        }
        if (solicitud.solicitudConceptos.length) {
            for(let i=0; i < solicitud.solicitudConceptos.length; i++)
            {
                if(solicitud.solicitudConceptos[i].conceptoID === 480){
                    total +=  solicitud.solicitudConceptos[i].costo;
                }   
            }
        }
        return total;
    }

    const correoCall = async (cotizacionId) => {
        const result = await apiSourceCommon.postAsync<any>("/solicitud-servicio/enviar-correo-solicitud/" + cotizacionId, {username: localStorage.getItem("usuario_nombre")});
        return result;
    }

    const generarSolicitudSinHD = async (solicitudSinHD:any) => {
        let solicitudHD = setSolicitudDto();
        solicitudHD.tipoServicioID = solicitudSinHD.tipoServicio.id;
        solicitudHD.esHomeDelivery = solicitudSinHD.esHomeDelivery;
        return guardarSolicitudServicioHD(solicitudHD);
    }

    const generarSolicitud = async () => {
        if(esInternamiento){//folio 3823
            await swal.fire({
                titleText: traducirMessage(11),
                text: traducirMessage(324), // 'El cruce fronterizo no es válido para el servicio Intra USA.',
                type: 'info'
            });
        }///fin 3823
        
        if(archivosAdjuntos.length === 0 && props.cliente.adjuntarCarta){
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(286),//traducirMessage(95), // "Favor de anexar la carta de instrucción.",
                type: 'warning',
            });
            return
        }

        if (!state.tipoEnvio) {
            enqueueSnackbar(traducirMessage(118), // "Favor de seleccionar el tipo de envío.", 
                { variant: "error" });
            return
        }

        if (!aceptaTerminos) {
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(95), // "Favor de aceptar los términos y condiciones.",
                type: 'warning',
            });
            return;
        }
        

        setLoading(true);
        guardarSolicitudServicio().then(resultSS => {

            actualizaLoginData(Number(props.cliente.id), Number(props.usuario.id), localStorage.getItem("usuario_nombre")).then(result => {
        
                let documentoId = 0;
                if (result !== null && result.cliente !== null && result.cliente?.id !== null) {
                    result.cliente.habilitarDatosGenericos = result.cliente.clienteConfiguracionDatosGenericos?.datosGenericos;
                    result.cliente.habilitarDatosComplementarios = false;
                    if (result.cliente.clienteConfiguracionComplemento && result.cliente.clienteConfiguracionComplemento.datosComplementariosCartaPorte) {
                        result.cliente.habilitarDatosComplementarios = true;
                    }
                    if (result.cliente.clienteConfiguracionComplementoCartaPorte && result.cliente.clienteConfiguracionComplementoCartaPorte.activo) {
                        result.cliente.habilitarDatosComplementariosCartaPorte = true;
                    }
                    if (result.cliente.clienteConfiguracionCompCartaPorteDetalle && result.cliente.clienteConfiguracionCompCartaPorteDetalle.activo) {
                        result.cliente.habilitarDatosCompCartaPorteDetalle = true;
                    }
                    if (result.cliente.clienteConfiguracionMarkup && result.cliente.clienteConfiguracionMarkup) {
                        result.cliente.clienteConfiguracionMarkup = result.cliente.clienteConfiguracionMarkup;
                    }
                    if (result.cliente.clienteConfiguracionValidacionCoberturaEAD && result.cliente.clienteConfiguracionValidacionCoberturaEAD.activo) {
                        result.cliente.habilitarValidacionCoberturaEAD = true;
                    }
                    if (result.cliente.clienteConfiguracionValidacionCoberturaRAD && result.cliente.clienteConfiguracionValidacionCoberturaRAD.activo) {
                        result.cliente.habilitarValidacionCoberturaRAD = true;
                    }
                    //Se comenta esta linea para colocar siempre en false (0) la variable y así no mostrar nunca la sección markup
                    result.cliente.clienteConfiguracionMarkupDetalle = result.cliente.clienteConfiguracionMarkupDetalle === null ? 0 : result.cliente.clienteConfiguracionMarkupDetalle;
                    //result.cliente.clienteConfiguracionMarkupDetalle = 0;

                    if (result.cliente?.documentos !== null) {
                        result.cliente.documentos?.forEach(d => {
                            documentoId++;
                            d.id = documentoId;
                        });
                    }
                    result.cliente.tieneConveniosHD = result.tieneConveniosHD;
                    localStorage.setItem("etiquetas", JSON.stringify(result.etiquetas));
                    localStorage.setItem("idioma", result.idioma);
                    props.saveCliente(result.cliente);
                    
                    if(result.diasRAD !== undefined && result.diasRAD !== "" && result.diasRAD !== null){
                        localStorage.setItem("diasRad", result.diasRAD);
                    }
                    else{
                        localStorage.setItem("diasRad", "0");
                    }
                    if (props.solicitudCopia.cotizacionId && props.solicitudCopia.cotizacionId > 0) {
                        actualizaEstatusCotizacion(props.solicitudCopia.cotizacionId);
                    }
                    localStorage.setItem("clienteString", JSON.stringify(result.cliente));
                    let direccionRemitente;
                    let direccionDestinatario;
                    resultSS.tipoMarkupId = tipoMarkupId;
                    obtenerCoordenadasDistribuidor(props.cliente.id, props.solicitud.distribuidorRemitente.clienteDistribuidorID).then(response => {
                        if (response != null) {
                            direccionRemitente = { latitude: response.latitudVerificada, longitude: response.longitudVerificada };
                            setdatosRemitente(direccionRemitente);
                            obtenerCoordenadasDistribuidor(props.cliente.id, props.solicitud.distribuidorDestinatario.clienteDistribuidorID).then(response => {
                                if (response != null) {
        
                                    direccionDestinatario = {
                                        latitude: response.latitudVerificada,
                                        longitude: response.longitudVerificada
                                    };
                                    setdatosDestinatario(direccionDestinatario);
                                    setNuevaSolicitud(resultSS, direccionRemitente, direccionDestinatario);
                                }
        
                            });
                        }
        
                    }).catch(() => {
                        setNuevaSolicitud(resultSS, datosRemitente, datosDestinatario);
                    });
                }
            })    
        }).catch(err => {
             setLoading(false);
            let messageError = !!err.data ? err.data.error.message : err;
            let message = "";
            if (err.data !== undefined) {
                message = err?.data?.error?.message;
            } else {
                if(typeof messageError === "object"){
                    message = messageError.message ?? "";
                }else{
                    message = "";
                }
            }
            if(props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo){
                if(message.includes("ERROR TARIFA HOME DELIVERY")){
                
                    swal.fire({
                        titleText: traducirLabel(343), //'Tipo de Servicio',
                        text: traducirMessage(310),
                        type: 'warning',
                        showConfirmButton: true,
                        showCancelButton: true,
        
                        cancelButtonAriaLabel: traducirButton(6), // 'CANCELAR',
                        confirmButtonAriaLabel: traducirButton(17), // 'ACEPTAR'
                    
                    }).then((result) => {
                        if (result.value == true) {
                            const nuevaSolicitudServicio = new Solicitud(props.solicitudCopia);
                            nuevaSolicitudServicio.tipoServicio = nuevaSolicitudServicio.tipoServicioReal;
                            nuevaSolicitudServicio.esHomeDelivery = false;
                            props.setSolicitud(nuevaSolicitudServicio);
                            props.setSolicitudCopia(nuevaSolicitudServicio);
                            props.siguienteSeccion(enums.estatusSolicitud.tipoEnvio, nuevaSolicitudServicio, 0, null);
                        }
                    })
                }else if(message.includes("timeout") || message.includes("EnableRetryOnFailure()")){
                    swal.fire({
                        titleText: traducirLabel(349),
                        text: traducirMessage(323),
                        type: "error"
                    });
                }
                else{
                    swal.fire({
                        titleText: traducirMessage(272),//'¡Error!'
                        text: message === "" ? traducirMessage(94) : (message.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") ? traducirMessage(306) : (message.includes("PLEASE VERIFY AND SELECT A VALID CLASS") ? traducirMessage(306) : message )),
                        type: 'error',
                    }).then((result) => {
                        if(result.value && (message.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") || message.includes("PLEASE VERIFY AND SELECT A VALID CLASS"))){
                            const nuevaSolicitudServicio = new Solicitud(initialSolicitud);
                            nuevaSolicitudServicio.claseId = -1;
                            props.siguienteSeccion(enums.estatusSolicitud.datosMercancia, nuevaSolicitudServicio, 0, null);
                        }
                    });
                }
            }
            else{
                if(message.includes("ERROR TARIFA HOME DELIVERY")){
            
                    swal.fire({
                        titleText: traducirLabel(343), //'Tipo de Servicio',
                        text: traducirMessage(310),
                        type: 'warning',
                        showConfirmButton: true,
                        showCancelButton: true,
        
                        cancelButtonAriaLabel: traducirButton(6), // 'CANCELAR',
                        confirmButtonAriaLabel: traducirButton(17), // 'ACEPTAR'
                    
                    }).then((result) => {
                        if (result.value == true) {
                            setLoading(true);
                            const nuevaSolicitudServicio = new Solicitud(props.solicitudCopia);
                            nuevaSolicitudServicio.tipoServicio = nuevaSolicitudServicio.tipoServicioReal;
                            nuevaSolicitudServicio.esHomeDelivery = false;
                            props.setSolicitudCopia(nuevaSolicitudServicio);
                            generarSolicitudSinHD(nuevaSolicitudServicio).then(resultSolicitud => { 
                                setLoading(true);
                                setNuevaSolicitud(resultSolicitud, datosRemitente, datosDestinatario);
                                
                            }).catch(err => { console.log(err); })
                        }
                    })
                }else if(message.includes("timeout") || message.includes("EnableRetryOnFailure()")){
                    swal.fire({
                        titleText: traducirLabel(349),
                        text: traducirMessage(323),
                        type: "error"
                    });
                }
                else{
                    swal.fire({
                        titleText: traducirMessage(272),//'¡Error!'
                        text: message === "" ? traducirMessage(94) : (message.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") ? traducirMessage(306) : (message.includes("PLEASE VERIFY AND SELECT A VALID CLASS") ? traducirMessage(306) : message )),
                        type: 'error',
                    }).then((result) => {
                        if(result.value && (message.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") || message.includes("PLEASE VERIFY AND SELECT A VALID CLASS"))){
                            const nuevaSolicitudServicio = new Solicitud(initialSolicitud);
                            nuevaSolicitudServicio.claseId = -1;
                            props.siguienteSeccion(enums.estatusSolicitud.datosMercancia, nuevaSolicitudServicio, 0, null);
                        }
                    });
                }
            }            
        });
    };

    const obtenerCoordenadasDistribuidor = async (clienteId, clienteDistribuidorId) => {
        const result = await apiSourceCommon.obtenerAsync<any>("cliente-distribuidor-direccion/by-cliente-distribuidor", { clienteId: clienteId, clienteDistribuidorId: clienteDistribuidorId });
        return result;
    }

    const setNuevaSolicitud = (response, remitente, destinatario) => {
        correoCall(response.solicitudServicioID).then(() => { });

        let fechaCitaRadArray;
        let fechaCitaEadArray;
        let fechaCitaRadDate;
        let fechaCitaRadTime;
        let fechaCitaEadDate;
        let fechaCitaEadTime;

        if(response.fechaCitaRAD!==null){
            fechaCitaRadArray = response.fechaCitaRAD.split('T');
            fechaCitaRadDate = fechaCitaRadArray[0].split('-');
            fechaCitaRadTime = fechaCitaRadArray[1].split(':');
        }
        
        if(response.fechaCitaEAD!==null){
            fechaCitaEadArray = response.fechaCitaEAD.split('T');        
            fechaCitaEadDate = fechaCitaEadArray[0].split('-');
            fechaCitaEadTime = fechaCitaEadArray[1].split(':');
        }

        const nuevaSolicitudServicio = new Solicitud(initialSolicitud);
        nuevaSolicitudServicio.proyecto = {
            id: response.proyectoID,
            descripcion: response.proyecto?.descripcion
        }

        nuevaSolicitudServicio.facturador = {
            id: response.facturador?.id,
            clienteNombre: response.facturador?.nombre,
            clienteRFC: response.facturador?.rfc
        }
        nuevaSolicitudServicio.seccionId = 8;
        nuevaSolicitudServicio.estatusId = 8;
        nuevaSolicitudServicio.completada = true;
        nuevaSolicitudServicio.modificar = true;
        nuevaSolicitudServicio.numGuia = response.numGuia;
        nuevaSolicitudServicio.areaServicioDestinoId = response.areaServicioDestinatarioID;
        nuevaSolicitudServicio.areaServicioOrigenId = response.areaServicioRemitenteID;
        nuevaSolicitudServicio.claseId = response.claseID;
        nuevaSolicitudServicio.esSeguroBasico = response.esSeguroBasico === 1;
        nuevaSolicitudServicio.esSeguroMercancia = response.esSeguroMercancia === 1;
        nuevaSolicitudServicio.valorMercancia = response.valorMercancia !== null ? response.valorMercancia : 0;
        nuevaSolicitudServicio.unidadMedidaPesoId = response.unidadMedidaMercanciaID;
        nuevaSolicitudServicio.unidadMedidaLongitudId = response.unidadMercanciaID;
        nuevaSolicitudServicio.serviciosAdicionales = response.solicitudConceptos;
        nuevaSolicitudServicio.solicitudId = response.solicitudServicioID;
        nuevaSolicitudServicio.id = response.solicitudServicioID;
        nuevaSolicitudServicio.correo = response.correo;
        nuevaSolicitudServicio.tipoRecoleccionIdOrigen = response.esRAD === 1 ? enums.tipoRecoleccion.comercial : response.ocurreOrigen === 1 ? enums.tipoRecoleccion.ocurre : enums.tipoRecoleccion.residencial;
        nuevaSolicitudServicio.tipoRecoleccionIdDestino = response.esEAD === 1 ? enums.tipoRecoleccion.comercial : response.ocurreDestino === 1 ? enums.tipoRecoleccion.ocurre : enums.tipoRecoleccion.residencial;
        nuevaSolicitudServicio.tipoEnvio = response.tipoEnvio;
        nuevaSolicitudServicio.tipoEnvioId = response.tipoEnvioID;
        nuevaSolicitudServicio.nombreTarifaAlmex = response.nombreTarifaAlmex;
        nuevaSolicitudServicio.empresaTarifaAlmex = response.empresaTarifaAlmex;
        nuevaSolicitudServicio.telefonoTarifaAlmex = response.telefonoTarifaAlmex;
        nuevaSolicitudServicio.esParticularTarifaAlmex = response.empresaTarifaAlmex !== null && response.empresaTarifaAlmex !== "" ? 2 : 1;
        nuevaSolicitudServicio.tipoServicio = props.solicitud.tipoServicio;
        nuevaSolicitudServicio.archivosAdjuntos = response.solicitudArchivos;
        nuevaSolicitudServicio.totalPesoMercancia = response.totalPesoMercancia;
        nuevaSolicitudServicio.totalPesoFacturado = response.totalPesoFacturado;
        nuevaSolicitudServicio.montoPesoFacturado = getTotalPesoFacturado(response);
        nuevaSolicitudServicio.totalPesoVolumen = response.totalPesoVolumen;
        nuevaSolicitudServicio.valorMercancia = response.valorMercancia;
        nuevaSolicitudServicio.costoSeguro = response.solicitudDesgloseFleteSeguro != undefined && response.solicitudDesgloseFleteSeguro.length > 0 ? response.solicitudDesgloseFleteSeguro[0].valor : 0;
        nuevaSolicitudServicio.costoMarkup = response.markupMonto;
        nuevaSolicitudServicio.total = response.total;
        nuevaSolicitudServicio.iva = response.iva;
        nuevaSolicitudServicio.retencion = response.retencion;
        nuevaSolicitudServicio.subtotal = response.subTotal;
        nuevaSolicitudServicio.tipoSolicitud = 'solicitud servicio';
        nuevaSolicitudServicio.sucursalOrigen = response.sucursalRemitente;
        nuevaSolicitudServicio.sucursalDestino = response.sucursalDestinatario;
        nuevaSolicitudServicio.direccionRemitente = response.direccionRemitente;
        nuevaSolicitudServicio.direccionDestinatario = response.direccionDestinatario;
        nuevaSolicitudServicio.markupMonto = response.markupMonto;
        nuevaSolicitudServicio.markupPorcentaje = response.markupPorcentaje;
        nuevaSolicitudServicio.tipoMarkupId = response.tipoMarkupId;
        nuevaSolicitudServicio.serviciosAdicionales = setServicio_ServiciosAdicionales(response.solicitudConceptos);
        nuevaSolicitudServicio.archivosAdjuntos = setSolicitudArchivosAdjuntos(response.solicitudArchivos);
        if(response.fechaCitaRAD!==null){
            nuevaSolicitudServicio.fechaCitaRad = new Date(fechaCitaRadDate[0],fechaCitaRadDate[1]-1,fechaCitaRadDate[2],fechaCitaRadTime[0],fechaCitaRadTime[1]);
        }
        if(response.fechaCitaEAD!==null){
            nuevaSolicitudServicio.fechaCitaEad = new Date(fechaCitaEadDate[0],fechaCitaEadDate[1]-1,fechaCitaEadDate[2],fechaCitaEadTime[0],fechaCitaEadTime[1]);
        }
        if (response.contactoRemitente != null) {
            let contacto = new Contacto({
                id: response.contactoRemitente.clienteDistribuidorContactoID,
                nombre: response.contactoRemitente.nombreClienteDistribuidorContacto,
                telefono: response.contactoRemitente.telefono,
                correo: response.contactoRemitente.correo,
            });

            nuevaSolicitudServicio.contactoOrigen = contacto;
            nuevaSolicitudServicio.SetContactoOrigen(contacto);
        }
        if (response.contactoDestinatario != null) {
            nuevaSolicitudServicio.contactoDestino = new Contacto({
                id: response.contactoDestinatario.clienteDistribuidorContactoID,
                nombre: response.contactoDestinatario.nombreClienteDistribuidorContacto,
                telefono: response.contactoDestinatario.telefono,
                correo: response.contactoDestinatario.correo,
            });
        }

        if (response?.distribuidorRemitente?.colonium != null) {
            nuevaSolicitudServicio.coloniaOrigen = new Colonia({
                id: response.distribuidorRemitente.colonium.id,
                nombreColonia: response.distribuidorRemitente.colonium.nombreColonia,
                codigoPostal: response.distribuidorRemitente.colonium.codigoPostal,
                pais: response.distribuidorRemitente.colonium.pais,
                estado: response.distribuidorRemitente.colonium.estado,
                ciudad: response.distribuidorRemitente.colonium.ciudad,
                nombre: response.distribuidorRemitente.colonium.nombre,
                descripcion: response.distribuidorRemitente.colonium.descripcion
            });
        }

        if (response?.distribuidorDestinatario?.colonium != null) {
            nuevaSolicitudServicio.coloniaDestino = new Colonia({
                id: response.distribuidorDestinatario.colonium.id,
                nombreColonia: response.distribuidorDestinatario.colonium.nombreColonia,
                codigoPostal: response.distribuidorDestinatario.colonium.codigoPostal,
                pais: response.distribuidorDestinatario.colonium.pais,
                estado: response.distribuidorDestinatario.colonium.estado,
                ciudad: response.distribuidorDestinatario.colonium.ciudad,
                nombre: response.distribuidorDestinatario.colonium.nombre,
                descripcion: response.distribuidorDestinatario.colonium.descripcion
            });
        }

        if (response?.distribuidorRemitente != null) {
            nuevaSolicitudServicio.distribuidorRemitente = {
                id: response.distribuidorRemitente.clienteDistribuidorID,
                nombre: response.distribuidorRemitente.nombreClienteDistribuidor,
                direccion: response.distribuidorRemitente.calle,
                clienteDistribuidorID: response.distribuidorRemitente.clienteDistribuidorID,
                colonia: response.distribuidorRemitente.colonium,
                codigoPostal: response.distribuidorRemitente.codigoPostal,
                paisId: response.distribuidorRemitente.paisID,
                estadoId: response.distribuidorRemitente.estadoID,
                ciudadId: response.distribuidorRemitente.ciudadID,
                latitude: remitente.latitude,
                longitude: remitente.longitude
            };
        }
        if (response.distribuidorDestinatario != null) {
            nuevaSolicitudServicio.distribuidorDestinatario = {
                id: response.distribuidorDestinatario.clienteDistribuidorID,
                nombre: response.distribuidorDestinatario.nombreClienteDistribuidor,
                direccion: response.distribuidorDestinatario.calle,
                clienteDistribuidorID: response.distribuidorDestinatario.clienteDistribuidorID,
                colonia: response.distribuidorDestinatario.colonium,
                codigoPostal: response.distribuidorDestinatario.codigoPostal,
                paisId: response.distribuidorDestinatario.paisID,
                estadoId: response.distribuidorDestinatario.estadoID,
                ciudadId: response.distribuidorDestinatario.ciudadID,
                latitude: destinatario.latitude,
                longitude: destinatario.longitude
            };
        }
        nuevaSolicitudServicio.sucursalOrigen = response.sucursalRemitente;
        nuevaSolicitudServicio.sucursalDestino = response.sucursalDestinatario;
        if (response.solicitudMercancias.length > 0) {
            const copiaMercancias: Mercancia[] = [];

            response.solicitudMercancias.forEach(mercancia => {
                const nuevaMercancia = new Mercancia(initialMercancia);
                nuevaMercancia.id = mercancia.solicitudMercanciaID;
                nuevaMercancia.embalaje = mercancia.embalaje;
                nuevaMercancia.embalajeId = mercancia.embalajeID;
                nuevaMercancia.largo = mercancia.largo;
                nuevaMercancia.alto = mercancia.alto;
                nuevaMercancia.altoReal = mercancia.altoReal;
                nuevaMercancia.ancho = mercancia.ancho;
                nuevaMercancia.cantidad = mercancia.cantidad;
                nuevaMercancia.esEstibable = mercancia.esNoEstibable;
                nuevaMercancia.peso = mercancia.peso;
                nuevaMercancia.volumen = mercancia.volumen;
                nuevaMercancia.skuID = mercancia.skuID;
                nuevaMercancia.skuSeleccionado = (mercancia.skuID > 0) 
                    ? 
                    {
                        alto: mercancia.alto || 0,
                        largo: mercancia.largo || 0,
                        ancho: mercancia.ancho || 0,
                        peso: mercancia.peso || 0,
                        embalajeId: mercancia.embalajeID || '',
                        clienteSkuId: mercancia.skuID,
                        item: mercancia.skuItem || '',
                        id: mercancia.skuID, // De IAutocomplete
                        nombre: `${mercancia.skuItem ?? ''} ${mercancia.skuDescripcion ?? ''}`.trim(), // De IAutocomplete
                    } as IClienteSku : null;

                copiaMercancias.push(nuevaMercancia);
            });
            props.saveMercancias(copiaMercancias);
        }

        if (props.solicitudCopia.clienteReferencias?.length) {
            let clienteReferencias: any = [];
            props.solicitudCopia.clienteReferencias?.forEach(ref => {
                clienteReferencias.push({
                    descripcion: ref.descripcion,
                    longitud: ref.longitud,
                    solicitudServicioID: response.solicitudServicioID,
                    auditUsuarioID: 0,
                    clienteID: props.cliente.id,
                    clienteReferenciaID: ref.clienteReferenciaID,
                    valor: ref.valor.toString()
                });

            });
            guardarSolicitudReferencias(clienteReferencias).then(() => {
                nuevaSolicitudServicio.clienteReferencias = clienteReferencias;

                setState(nuevaSolicitudServicio);
                setSolicitud(nuevaSolicitudServicio);
                setSolicitudCopia(nuevaSolicitudServicio);

                setLoading(false);
                if((props.cliente.habilitarClienteLogistico && !props.cliente.clienteConfiguracionMarkupDetalle.activo) 
                || (!props.cliente.habilitarClienteLogistico && !props.cliente.clienteConfiguracionMarkupDetalle.activo)
                || (!props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo)){
                    props.siguienteSeccion(enums.estatusSolicitud.resumen, nuevaSolicitudServicio, 0, null, remitente, destinatario);
                }
                if(props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo)
                {
                    let solicitud=setSolicitudDto();
                    solicitud.fechaCitaRAD = nuevaSolicitudServicio.fechaCitaRad;
                    solicitud.fechaCitaEAD = nuevaSolicitudServicio.fechaCitaEad;
                    solicitud.fechaCitaRADCedis = nuevaSolicitudServicio.fechaCitaRadCedis;
                    solicitud.fechaCitaEADCedis = nuevaSolicitudServicio.fechaCitaEadCedis;
                    props.siguienteSeccion(enums.estatusSolicitud.resumen, nuevaSolicitudServicio, 0, null, remitente, destinatario ,solicitud);
                }
                ;
            })
        }
        else {
            setState(nuevaSolicitudServicio);
            setSolicitudCopia(nuevaSolicitudServicio);
            setLoading(false);
            props.siguienteSeccion(enums.estatusSolicitud.resumen, nuevaSolicitudServicio, 0, null, remitente, destinatario);
        }
    }

    const setSolicitudArchivosAdjuntos = (archivosSolicitud) => {
        let archivos: any = [];
        if (archivosSolicitud.length > 0) {
            archivosSolicitud.forEach(s => { 
                archivos.push({
                    nombre: s.nombreArchivo,
                    tipo: s.tipo,
                    file64: s.base64
                });              
            });
        }
        return archivos;
    }

    React.useEffect(() => {
        if (!state.tipoEnvio || !props.tiposEnvio.some(e => e.id === state.tipoEnvio?.id)) {
            let tipoEnvios = {
                id: 1,
                nombre: traducirLabel(277),
                descripcion: '',
                detalle: '',
                seleccionado: true,
                icono: 'SERVICIO_ALMEX'
            }
            const copiaSolicitud = new Solicitud(props.solicitudCopia);

            copiaSolicitud.tipoEnvio = tipoEnvios;
            copiaSolicitud.tipoEnvioId = 1;

            setSolicitudCopia(copiaSolicitud);
            setState(copiaSolicitud);
        }

        if (props.solicitud.archivosAdjuntos) {
            setArchivosAdjuntos(props.solicitud.archivosAdjuntos);
        }
    }, []);

    const servicioAdicionalGuardado = (nombre: string) => {
        let value = 0;
        if (props.solicitud.serviciosAdicionales?.length) {
            let found = props.solicitud.serviciosAdicionales.filter(t => t.nombre === nombre);
            if (found.length) {
                value = 1;
            }
        }
        return value;
    }

    const setArchivosAdjuntosSolicitud = () => {
        let servicioArchivos: any = [];

        if (archivosAdjuntos?.length > 0) {
            servicioArchivos = [];
            archivosAdjuntos.forEach(s => {
                servicioArchivos.push({
                    solicitudServicioID: props.solicitud.id,
                    solicitudArchivoID: 0,
                    nombreArchivo: s.nombre,
                    tipo: s.tipo,
                    base64: s.file64,
                    auditFecha: new Date(),
                    auditUsuarioID: 0,
                    auditPCMod: "",
                });
            });
        }
        return servicioArchivos;
    }

    const setServicio_ServiciosAdicionales = (solicitud_serviciosAdicionales) => {
        let serviciosAdicionales: any = [];
        if (solicitud_serviciosAdicionales?.length) {
            solicitud_serviciosAdicionales.forEach(s => {
                serviciosAdicionales.push({
                    id: s.conceptoID,
                    concepto: s.concepto,
                    aplicaOrigen: s.esOrigen == 1,
                    aplicaDestino: s.esDestino == 1,
                    esOrigen: s.esOrigen,
                    esDestino: s.esDestino,
                    cantidadOrigen: s.esOrigen ? 1 : 0,
                    cantidadDestino: s.esDestino ? 1 : 0,
                    cantidad: s.cantidad,
                    costo: s.costo
                })

            });
        }
        return serviciosAdicionales;
    }

    const setMercancias = () => {
        let mercancias = [
            {
                solicitudServicioID: 0,
                solicitudMercanciaID: 0,
                cantidad: 0,
                embalajeID: 0,
                largo: 0,
                ancho: 0,
                alto: 0,
                peso: 0,
                volumen: 0,
                esNoEstibable: 0,
                convenioID: 0,
                tarifarioID: 0,
                noTarima: 0,
                //auditFecha: undefined,
                auditUsuarioID: 0,
                auditPCMod: "",
                densidad: 0,
                pesoFacturado: 0,
                servicioID: 0,
                altoReal: 0,
                skuID: 0
            }
        ];
        if (props.mercancias?.length) {
            mercancias = [];
            props.mercancias.forEach(s => {
                mercancias.push({
                    solicitudServicioID: props.cotizacionId,
                    solicitudMercanciaID: s.id,
                    cantidad: s.cantidad ? s.cantidad : 0,
                    embalajeID: s.embalajeId ? s.embalajeId : 0,
                    largo: s.largo ? s.largo : 0,
                    ancho: s.ancho ? s.ancho : 0,
                    alto: s.alto ? s.alto : 0,
                    peso: s.peso ? s.peso : 0,
                    volumen: s.volumen ? s.volumen : 0,
                    esNoEstibable: s.esEstibable ? 1 : 0,
                    convenioID: 0,
                    tarifarioID: 0,
                    noTarima: 0,
                    //  auditFecha: undefined,
                    auditUsuarioID: 0,
                    auditPCMod: "",
                    densidad: 0,
                    pesoFacturado: 0,
                    servicioID: 0,
                    altoReal: s.altoReal ? s.altoReal : 0,
                    skuID: s.skuID ? s.skuID : 0
                })

            });
        }
        return mercancias;
    }

    const setMercanciasComplementarias = () => {
        let mercancias = [
            {
                solicitudServicioID: 0,
                solicitudMercanciaID: 0,
                cantidad: 0,
                claveUnidad: '',
                claveProducto: '',
                descripcion: '',
                claveFraccionArancelaria: '',
                uuidComprobante: '',
                pesoKgs: 0,
                auditUsuarioID: 0,
                auditPCMod: "",
                servicioID: 0,
            }
        ];
        if (props.mercanciasComplementarias?.length) {
            mercancias = [];
            props.mercanciasComplementarias.forEach(s => {
                mercancias.push({
                    solicitudServicioID: props.cotizacionId,
                    solicitudMercanciaID: s.id,
                    cantidad: s.cantidad ? s.cantidad : 0,
                    claveUnidad: s.claveUnidadId ? s.claveUnidadId : '',
                    claveProducto: s.claveProductoId ? s.claveProductoId : '',
                    descripcion: s.descripcionMercancia ? s.descripcionMercancia : '',
                    claveFraccionArancelaria: s.claveFraccionArancelariaId ? s.claveFraccionArancelariaId : '',
                    uuidComprobante: s.uuidComprobante ? s.uuidComprobante : '',
                    pesoKgs: s.peso ? s.peso : 0,
                    auditUsuarioID: 0,
                    auditPCMod: "",
                    servicioID: 0
                })

            });
        }
        return mercancias;
    }

    const actualizaEstatusCotizacion = async (cotizacionId) => {
        const result = await apiSourceCommon.postAsync<any>("/cotizacion/cambia-estatus-cotizacion/" + cotizacionId,{username: localStorage.getItem("usuario_nombre")});
        return result;
    }

    const setComercioExterior = () => {
        let comercioExterior = props?.solicitud?.comercioExterior;
        if(comercioExterior == undefined || comercioExterior == null)
            return null;

        return {    
                    solicitudServicioId: props.solicitud?.solicitudId ?? 0,
                    solicitudServicioComercioExteriorId: comercioExterior.solicitudComercioExteriorId ?? 0,
                    tipoComercioExteriorId: comercioExterior.tipoComercioExteriorId
        };
    }

    const setCruceFronterizo = () => {
        let cruceFronterizo = props?.solicitud?.cruceFronterizo;
        if(cruceFronterizo == undefined || cruceFronterizo == null)
            return null;

        let cruce = {
            solicitudServicioComercioExteriorId: cruceFronterizo.solicitudComercioExteriorId ?? 0,
            tipoServicioInternacionalId: cruceFronterizo.tipoServicioInternacionalId,
            tipoMovimientoServicioInternacionalId: cruceFronterizo.tipoMovimientoServicioInternacionalId,
            cruceInternacionalId: cruceFronterizo.cruceInternacionalId,
            esIntraUSA: cruceFronterizo.esIntraUSA,
            solicitudServicioId: props?.solicitud?.solicitudId ?? 0
        };
        return cruce;
    }

    const setSucursal = (sucursal: number|undefined, esSucursalOrigen: boolean, paisIdOrigenDestino: number) => {
        let sucursalId = sucursal ?? 0;
        //Para servicios internacionales, reemplazar sucursal origen/destino por sucursal del cruce fronterizo
        if(paisIdOrigenDestino == enums.pais.usa){
            let sucursalCruceId = props.solicitud.cruceFronterizo?.sucursalCruceId ?? 0;
            return sucursalCruceId;
        }else{
            return sucursalId;
        }
    }

    const setSolicitudDto = (): ISolicitudServicioDto => {

        props?.solicitud?.fechaCitaRad?.setMinutes(props?.solicitud?.fechaCitaRad?.getMinutes() - props?.solicitud?.fechaCitaRad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEad?.setMinutes(props?.solicitud?.fechaCitaEad?.getMinutes() - props?.solicitud?.fechaCitaEad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaRadCedis?.setMinutes(props?.solicitud?.fechaCitaRadCedis?.getMinutes() - props?.solicitud?.fechaCitaRadCedis?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEadCedis?.setMinutes(props?.solicitud?.fechaCitaEadCedis?.getMinutes() - props?.solicitud?.fechaCitaEadCedis?.getTimezoneOffset())

        let fechaCitaRad = props?.solicitud?.fechaCitaRad;
        let fechaCitaEad = props?.solicitud?.fechaCitaEad;
        let fechaCitaRadCedis = props?.solicitud?.fechaCitaRadCedis;
        let fechaCitaEadCedis = props?.solicitud?.fechaCitaEadCedis;
        let sucursalOrigenId = props?.solicitud?.sucursalOrigen?.id ?? 0;
        let sucursalDestinoId = props?.solicitud?.sucursalDestino?.id ?? 0;
               
        return {
            solicitudServicioID: props.solicitudCopia.id ? props.solicitudCopia.id : props.solicitud.id && props.solicitud.id > 0 ? props.solicitudCopia.id : 0,
            empresaID: 0,
            cotizacionID: props.solicitudCopia.cotizacionId ? props.solicitudCopia.cotizacionId : 0,
            estatusSolicitudID: 0,
            clienteID: props.cliente.id,
            remitenteID: props.solicitud.distribuidorRemitente ? props.solicitud.distribuidorRemitente.clienteDistribuidorID : props.solicitudCopia.distribuidorRemitente.clienteDistribuidorID,
            destinatarioID: props.solicitud.distribuidorDestinatario ? props.solicitud.distribuidorDestinatario.clienteDistribuidorID : props.solicitudCopia.distribuidorDestinatario.clienteDistribuidorID,
            sucursalClienteID: 0,
            sucursalRemitenteID: setSucursal(sucursalOrigenId, true, props?.solicitud?.paisIdOrigen),
            sucursalDestinatarioID: setSucursal(sucursalDestinoId, true, props?.solicitud?.paisIdDestino),
            areaServicioClienteID: 0,
            areaServicioRemitenteID: props?.solicitud?.areaServicioOrigenId ?? 0,
            areaServicioDestinatarioID: props?.solicitud?.areaServicioDestinoId ?? 0,
            direccionCliente: "",
            direccionRemitente: props.solicitud.direccionRemitente || "",
            direccionDestinatario: props.solicitud.direccionDestinatario || "",
            tipoServicioID: props.solicitudCopia.tipoServicio?.id ? props.solicitudCopia.tipoServicio?.id : ((props.solicitud.tipoServicio == undefined) ? 0 : (Number(props.solicitud.tipoServicio?.id))),
            tipoEnvioID: state.tipoEnvio?.id ?? 0,
            proyectoID: props.solicitudCopia.proyecto?.id ? props.solicitudCopia.proyecto?.id : 0,
            esFlete: 0,
            esEad: (props?.solicitudCopia?.tipoRecoleccionIdDestino === enums.tipoRecoleccion.residencial) ? 1 : (props?.solicitud?.esEad ? 1 : 0),
            fechaCitaEAD: props?.solicitud?.fechaCitaEad ? fechaCitaEad : undefined,
            fechaCitaRAD: props?.solicitud?.fechaCitaRad ? fechaCitaRad : undefined,
            fechaCitaEADCedis: props?.solicitud?.fechaCitaEadCedis ? fechaCitaEadCedis : undefined,
            fechaCitaRADCedis: props?.solicitud?.fechaCitaRadCedis ? fechaCitaRadCedis : undefined,
            fechaRecoleccion: props?.solicitud?.fechaRecoleccion ? props?.solicitud?.fechaRecoleccion : undefined,
            esRad: (props?.solicitudCopia?.tipoRecoleccionIdOrigen === enums.tipoRecoleccion.residencial) ? 1 : (props?.solicitud?.esRad ? 1 : 0),
            esSeguroMercancia: props.solicitudCopia?.esSeguroMercancia ? 1 : 0,
            esSeguroBasico: props.solicitudCopia?.esSeguroBasico ? 1 : 0,
            esCobrarEnDestino: servicioAdicionalGuardado("COBRO EN DESTINO") == 0 ? 0 : 1,
            valorMercancia: props?.solicitud.valorMercancia ? props?.solicitud.valorMercancia : 0,
            unidadMercanciaID: props.solicitudCopia?.unidadMedidaLongitudId ? props.solicitudCopia?.unidadMedidaLongitudId : 0,
            unidadMedidaMercanciaID: props.solicitudCopia?.unidadMedidaPesoId ? props.solicitudCopia?.unidadMedidaPesoId : 0,
            claseID: props.solicitudCopia.claseId ? props.solicitudCopia.claseId : 0,
            //clase: props.solicitudCopia.clase ? props.solicitudCopia.clase : '',
            descripcionMercancia: props.solicitudCopia.descripcionMercancia ? props.solicitudCopia.descripcionMercancia : "",
            fechaEnvioEstimado: undefined,
            fechaAlta: undefined,
            totalCantidadMercancia: 0,
            totalPesoMercancia: 0,
            totalVolumenMercancia: 0,
            totalPesoVolumen: 0,
            totalPesoFacturado: 0,
            convenioID: 0,
            fechaCancelacion: undefined,
            usuarioCancelaId: 0,
            monedaID: 0,
            descuento: 0,
            tipoCambio: 0,
            ivaID: 0,
            retencionID: 0,
            descuentoMonto: 0,
            iva: 0,
            retencion: 0,
            subTotal: 0,
            total: 0,
            retornoDocumentos: servicioAdicionalGuardado("RETORNO DOCUMENTOS"),
            observaciones: props.solicitudCopia.observaciones ? props.solicitudCopia.observaciones : props.solicitud.observaciones ? props.solicitud.observaciones : "",
            numGuiaRetorno: "",
            auditFecha: undefined,
            auditUsuarioID: 0,
            auditPCMod: props.usuario.nombre,
            nombre_Recibe: "",
            fecha_Recibe: undefined,
            estatusRetornoDocumentoId: 0,
            cruce: 0,
            entarimar: 0,
            cartaInstruccion: "",
            cartaInstruccionNombre: "",
            numGuia: props.solicitud.numGuia ? props.solicitud.numGuia : '',
            remitenteContacto: props.solicitud.contactoOrigen?.nombre ? props.solicitud.contactoOrigen?.nombre : '',
            destinatarioContacto: props.solicitud.contactoDestino?.nombre ? props.solicitud.contactoDestino?.nombre : '',
            esPendienteDefinirRAD: 0,
            esPendienteDefinirEAD: 0,
            telefonoAdicionalRemitente: "",
            recoleccionId: 0,
            esEADCita: 0,
            esRADCita: 0,
            esOcurreOrigen: props.solicitud?.ocurreOrigen ? props.solicitud?.ocurreOrigen : 0,
            esOcurreDestino: props.solicitud?.ocurreDestino ? props.solicitud?.ocurreDestino : 0,
            correo: props.solicitud?.correo ? props.solicitud?.correo : '',
            esMasiva: 0,
            tipoMasivaID: 0,
            fechaRADfin: undefined,
            remitenteContactoId: props.solicitud.contactoOrigen?.id,
            destinatarioContactoId: props.solicitud.contactoDestino?.id,
            grupoClienteId: 0,
            grupoProyectoId: props.solicitudCopia.proyecto?.id ? props.solicitudCopia.proyecto?.id : 0,
            esCapturaReferencia: false,
            esPlatinum: false,
            distribuidorLogisticoId: props.solicitud.facturador && props.solicitud.facturador?.id > 0 ? props.solicitud.facturador.id : 0,
            tipoFleteID: 0,
            tipoImpuestoID: 0,
            tipoImpuestoRetencionID: 0,
            esResidencialOrigen: !!props.solicitud?.esResidencialOrigen,
            esResidencialDestino: !!props.solicitud?.esResidencialDestino,
            markupMonto: montoMarkup ?? 0,
            markupPorcentaje: porcentajeMarkup ?? 0,
            solicitudConceptos: setServiciosAdicionales(props.solicitud),
            solicitudMercancias: setMercancias(),
            solicitudMercanciasComplementarias: setMercanciasComplementarias(),
            solicitudArchivos: setArchivosAdjuntosSolicitud(),
            EsRadCitaFueraHorario: props.solicitudCopia.EsRadCitaFueraHorario,
            RadCitaHoraDe: props.solicitudCopia.RadCitaHoraDe ? new Date("2021-01-01 " + props.solicitudCopia.RadCitaHoraDe + ":00") : new Date(),
            RadCitaHoraHasta: props.solicitudCopia.RadCitaHoraHasta ? new Date("2021-01-01 " + props.solicitudCopia.RadCitaHoraHasta + ":00") : new Date(),
            EsEadCitaFueraHorario: props.solicitudCopia.EsEadCitaFueraHorario,
            EadCitaHoraDe: props.solicitudCopia.EadCitaHoraDe ? new Date("2021-01-01 " + props.solicitudCopia.EadCitaHoraDe + ":00") : new Date(),
            EadCitaHoraHasta: props.solicitudCopia.EadCitaHoraHasta ? new Date("2021-01-01 " + props.solicitudCopia.EadCitaHoraHasta + ":00") : new Date(),
            RadCitaHoraFHDe: props.solicitudCopia.RadCitaHoraDe ?  props.solicitudCopia.RadCitaHoraDe + ":00" : '00:00:00',
            RadCitaHoraFHHasta: props.solicitudCopia.RadCitaHoraHasta ? props.solicitudCopia.RadCitaHoraHasta + ":00" : '00:00:00',
            EadCitaHoraFHDe: props.solicitudCopia.EadCitaHoraDe ?  props.solicitudCopia.EadCitaHoraDe + ":00" : '00:00:00',
            EadCitaHoraFHHasta: props.solicitudCopia.EadCitaHoraHasta ?  props.solicitudCopia.EadCitaHoraHasta + ":00" : '00:00:00',
            DocumentosRetorno: props.solicitud.documentosRetorno,
            idioma: localStorage.getItem("idioma") === null ? "es-MX" : localStorage.getItem("idioma"),
            tipoMarkupId: tipoMarkupId ?? 0,
            esHomeDelivery: (props?.solicitudCopia?.tipoServicio && Number(props.solicitudCopia.tipoServicio?.id)!==3) ? false : props.solicitudCopia.esHomeDelivery,
            solicitudServicioComercioExterior: setComercioExterior(),
            solicitudServicioCruceFronterizo: setCruceFronterizo(),
            eliminaRetornoDocumentos : props.solicitudCopia.eliminaRetornoDocumentos

        };
    };

    const guardarSolicitudServicioHD = async (solicitudDTO:any) => {
        const result = await apiSourceCommon.postAsync<ISolicitudDto>("/solicitud-servicio", solicitudDTO);
        props?.solicitud?.fechaCitaRad?.setMinutes(props?.solicitud?.fechaCitaRad?.getMinutes() + props?.solicitud?.fechaCitaRad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEad?.setMinutes(props?.solicitud?.fechaCitaEad?.getMinutes() + props?.solicitud?.fechaCitaEad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaRadCedis?.setMinutes(props?.solicitud?.fechaCitaRadCedis?.getMinutes() + props?.solicitud?.fechaCitaRadCedis?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEadCedis?.setMinutes(props?.solicitud?.fechaCitaEadCedis?.getMinutes() + props?.solicitud?.fechaCitaEadCedis?.getTimezoneOffset())
        return result;
    }

    const guardarSolicitudServicio = async () => {
        const result = await apiSourceCommon.postAsync<ISolicitudDto>("/solicitud-servicio", setSolicitudDto());
        props?.solicitud?.fechaCitaRad?.setMinutes(props?.solicitud?.fechaCitaRad?.getMinutes() + props?.solicitud?.fechaCitaRad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEad?.setMinutes(props?.solicitud?.fechaCitaEad?.getMinutes() + props?.solicitud?.fechaCitaEad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaRadCedis?.setMinutes(props?.solicitud?.fechaCitaRadCedis?.getMinutes() + props?.solicitud?.fechaCitaRadCedis?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEadCedis?.setMinutes(props?.solicitud?.fechaCitaEadCedis?.getMinutes() + props?.solicitud?.fechaCitaEadCedis?.getTimezoneOffset())
        return result;
    }

    const validarSolicitudServicioMarkup = async () => {
        const result = await apiSourceCommon.postAsync<ISolicitudServicioDto>("/solicitud-servicio/validar-tarifario", setSolicitudDto());
        props?.solicitud?.fechaCitaRad?.setMinutes(props?.solicitud?.fechaCitaRad?.getMinutes() + props?.solicitud?.fechaCitaRad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEad?.setMinutes(props?.solicitud?.fechaCitaEad?.getMinutes() + props?.solicitud?.fechaCitaEad?.getTimezoneOffset())
        props?.solicitud?.fechaCitaRadCedis?.setMinutes(props?.solicitud?.fechaCitaRadCedis?.getMinutes() + props?.solicitud?.fechaCitaRadCedis?.getTimezoneOffset())
        props?.solicitud?.fechaCitaEadCedis?.setMinutes(props?.solicitud?.fechaCitaEadCedis?.getMinutes() + props?.solicitud?.fechaCitaEadCedis?.getTimezoneOffset())
        return result;
    }

    const guardarSolicitudReferencias = async (referencia) => {
        const result = await apiSourceCommon.postAsync<boolean>("solicitud-cliente-referencia", referencia);
        return result;
    };

    const handleTipoEnvio = () => {
        if(props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo){
            setLoading(true);
            validarSolicitudServicioMarkup().then(result => {
                console.log(result);
                let totalMonto = 0;

                result.solicitudDesgloseFlete?.forEach(function(element){
                    totalMonto = totalMonto + element.valor;
                });

                result.solicitudDesgloseFleteEad?.forEach(function(element){
                    totalMonto = totalMonto + element.valor;
                });

                result.solicitudDesgloseFleteRad?.forEach(function(element){
                    totalMonto = totalMonto + element.valor;
                });
                
                setTotalValidaMarkup(totalMonto);
                setExpanded('Markup');
                setMarkupHabilitado(false);
                setLoading(false);
            }).catch(err => {
                setLoading(false);
                let message = "";
                if (err.data !== undefined) {
                    message = err?.data?.error?.message;
                } else{
                    message = "";
                }               
                swal.fire({
                    titleText: traducirMessage(272),//'¡Error!'
                    text: message === "" ? traducirMessage(94) : (message.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") ? traducirMessage(306) : (message.includes("PLEASE VERIFY AND SELECT A VALID CLASS") ? traducirMessage(306) : message )),
                    type: 'error',
                }).then((result) => {
                    if(result.value && (message.includes("FAVOR DE VERIFICAR SELECCIONAR UNA CLASE VALIDA") || message.includes("PLEASE VERIFY AND SELECT A VALID CLASS"))){
                        const nuevaSolicitudServicio = new Solicitud(initialSolicitud);
                        nuevaSolicitudServicio.claseId = -1;
                        props.siguienteSeccion(enums.estatusSolicitud.datosMercancia, nuevaSolicitudServicio, 0, null);
                    }
                });                
            });
        }
        else{
            setExpanded('Carta');
        }
    }

    const handleMarkup = () => {
        setExpanded('Carta');
    }

    const seleccionarTipoEnvio = (tipoEnvio: ITipoEnvio) => {
        const copiaSolicitud = new Solicitud({ ...state, tipoEnvio });
        copiaSolicitud.tipoEnvioId = tipoEnvio.id;
        copiaSolicitud.tipoEnvio = tipoEnvio;
        setSolicitudCopia(copiaSolicitud);
        setState(copiaSolicitud);
    };
    const handleChangePanel = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const getArchivos = (archivos: any) => {
        setArchivosAdjuntos(archivos);

        const copiaSolicitud = new Solicitud(props.solicitud);
        copiaSolicitud.archivosAdjuntos = archivos.length > 0 ? archivos : [];
        props.setSolicitudCopia(copiaSolicitud);
        props.setSolicitud(copiaSolicitud);

    }

    const getIconoTipoEnvio = (id) => {
        let icono: string;
        let tipoEnvioFilter = tiposEnvioIcono.filter(x => x.id == id)[0];
        icono = id === state.tipoEnvio?.id ? `${tipoEnvioFilter.icono}_seleccionado.jpg` : `${tipoEnvioFilter.icono}.jpg`;
        return icono;
    }

    const aceptaterminos = () => {
        window.open('http://ndocum.almex.com.mx/documentacion/pages/GenerarPDF.aspx?TipoPDF=8');
    }

    const handleTerminos = () => {
        setAceptaTerminos(true);
    }

    const handleSiguienteSeccion = (montoMarkup:any, cotizacion:any, porcentajeMarkup:any) => {
        if(props.solicitud.tipoSolicitud !== "cotizacion"){
            setMontoMarkup(montoMarkup);
            setPorcentajeMarkup(porcentajeMarkup);
            setTipoMarkupId(cotizacion.tipoMarkupId);
            setExpanded('Carta');
            setMarkupHabilitado(false);
            setCartaHabilitado(false);
        }
    };

    const handleChangeFields = () => {
        if(props.solicitud.tipoSolicitud !== "cotizacion"){
            setCartaHabilitado(true);
        }
    };

    const actualizaLoginData = async (clienteId, usuarioId, userName) => {
        const result = await apiSource.obtenerAsync<IDatosLogin>("login/login-data", { clienteId: clienteId, usuarioId: usuarioId, userName: userName });
        return result;
    };

    return (<>
        <Accordion expanded={expanded === 'TipoEnvio'} onChange={handleChangePanel('TipoEnvio')}>
            <AccordionSummary
                expandIcon={<Add />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography className={classes.heading}>
                    {/* TIPO ENVÍO */traducirLabel(331)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1} >
                    <Grid item sm={12}>
                        <div>

                            <Help comments={traducirMessage(63)} customStyle={{ top: "-10px", right: "-15px" }} />

                            <Box mb={3} className="title text-center">
                                {/* Seleccione el tipo de envío que desea */traducirMessage(243)}
                            </Box>

                            <Grid container spacing={3} justify="center">
                                {props.tiposEnvio?.map(t =>
                                    <TipoEnvio key={t.id} tipoEnvio={t} seleccionado={t.id === state.tipoEnvio?.id}
                                        onSelect={seleccionarTipoEnvio} icono={getIconoTipoEnvio(t.id)} />
                                )}
                            </Grid>

                        </div>
                    </Grid>

                    <Grid item sm={12} justify="flex-end">
                        <Box display="flex" justifyContent="flex-end" mt={2}>
                            <Box>

                                <Button variant="contained" color="primary" onClick={() => handleTipoEnvio()} >
                                    {/* Siguiente */traducirButton(15)}
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

            </AccordionDetails>
        </Accordion>

        {props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo &&
        <Accordion expanded={expanded === 'Markup'} onChange={handleChangePanel('Markup')}>
            <AccordionSummary disabled={markupHabilitado}
                expandIcon={<Add />}
                aria-controls="panel1a-content"
                id="panel1a-header">
                <Typography component={'span'} className={classes.heading}>
                    {/*Markup */
                        traducirMessage(289)}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1} >
                    <Grid item sm={12}>
                        <Markup siguienteSeccion={handleSiguienteSeccion} cotizacionId={totalValidaMarkup} solicitudDTO={props.solicitudDTO} handleChangeFields={handleChangeFields}/>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
        }

        <Accordion expanded={expanded === 'Carta'} onChange={handleChangePanel('Carta')}>
            <AccordionSummary
                expandIcon={<Add />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                disabled={cartaHabilitado}
            >
                <Typography className={classes.heading}>{traducirLabel(338)}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={1} >
                    <Grid item sm={12}>
                        <div>
                            <Box mb={3} className="title text-center">
                                {/* ¿Desea adjuntar algún archivo? */traducirMessage(20)}
                            </Box>

                            <Grid container spacing={3} justify="center">
                                <CartaInstruccion setArchivos={getArchivos} archivos={props.solicitud.archivosAdjuntos} />
                            </Grid>
                        </div>
                    </Grid>


                </Grid>

            </AccordionDetails>
        </Accordion>
        
        
        <Grid container className={classes.actions} style={{ backgroundColor: "white", padding: "10px" }}>
            <Grid item xs={10}>
            <div>
                <table>
                    <tr>
                        <td> <Checkbox name="aplicaOrigen" color="primary" size="small" checked={aceptaTerminos}
                            onChange={handleTerminos} /></td>
                        <td>
                            <span className={classes.link} onClick={aceptaterminos}>
                                {/* Acepto t&eacute;rminos y condiciones */traducirLabel(3)}
                            </span>
                        </td>
                    </tr>
                </table>

            </div>


            </Grid>
            <Grid item xs={2}>
            {expanded === "Carta" &&
                <NextButton nextStep={generarSolicitud} label={traducirLabel(151)} />
            }
            </Grid>
        </Grid>
        
        {/* {(props.cliente.habilitarClienteLogistico && props.cliente.clienteConfiguracionMarkupDetalle.activo)  &&
            <Grid container className={classes.actions} style={{ backgroundColor: "white", padding: "10px" }}>
                <Grid item xs={10}></Grid>
                <Grid item xs={2}>
                    <NextButton nextStep={generarSolicitud} label={traducirLabel(151)} />
                </Grid>
            </Grid>
        } */}
        {showLoading &&
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    mercancias: state.mercancias,
    mercanciasComplementarias: state.mercanciasDatosComplementarios,
    cliente: state.cliente,
    tiposEnvio: state.tiposEnvio,
    usuario: state.usuario,
    ayuda: state.ayuda
});

const mapDispatchToProps = {
    setSolicitudCopia: setSolicitudCopia,
    setSolicitud: setSolicitud,
    saveMercancias: saveMercancias,
    saveCliente: saveCliente
};

export default connect(mapStateToProps, mapDispatchToProps)(TipoEnvioSolicitudLista);
